<section class="section-white" *ngIf="coverageData">
  <div class="section-container-inside">
    <h2 class="section-heading mar-b-48">
      {{ coverageData?.header }}
    </h2>
    <div class="tabs-grey justfy-c">
      <!----- Africa ----->
      <ng-container *ngFor="let tab of coverageData.tabs; let i = index">
        <label
          (click)="tabHandler(i)"
          [ngClass]="activeTabIndex === i ? 'active' : ''"
          >{{ tab.fields?.tagText }}</label
        >
        <div class="tab-grey" [ngClass]="activeTabIndex === i ? 'active' : ''">
          <div class="section-country">
            <div
              class="country-currency"
              *ngFor="let flag of tab.fields.relatedComponents"
            >
              <img
                class="ico-48"
                src="{{ flag.fields.imageicon.fields?.file?.url }}"
                alt="{{ flag.fields.imageicon.fields?.title }}"
              />
              <a
                href="{{ 'Coverage/Countries/' + (flag.fields.link || '') | urlParams: queryParams }}"
                class="link-xl"
                >{{ flag.fields.title }}</a
              >
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
